import { createAction } from 'redux-act';
import { sendData, selectFormData } from './util';

export const setRequiredBadges = createAction('set required badges count');
export const setLevelName = createAction('set level name');
export const setLevels = createAction('set levels');
export const setErrors = createAction('set errors');
export const setSelectedBadges = createAction('set selected badges');
export const setIsSaving = createAction('set isSaving flag');

export const saveForm = (state, dispatch) => {
  const data = selectFormData(state);

  sendData(data)
    .then(response => {
      if (R.isNil(response.data.errors)) {
        window.location.reload();
        return;
      }

      dispatch(setErrors(response.data.errors));
      dispatch(setIsSaving(false));
    })
    .catch(() =>
      dispatch(setErrors({ common: 'Something bad happened. Try reloading the page' }))
    );
};
